export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'FILTER_CREATE':
      let containsLayer = false
      state.map(layer => {
        if (layer.id == payload.id) containsLayer = true
      })
      return containsLayer ? state : [payload, ...state]
    case 'FILTER_UPDATE':
      return state.map(item => (item.id === payload.id ? payload : item))
    case 'FILTER_DELETE':
      return state.filter(item => item.id !== payload)
    case 'FILTER_CLEAR':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
